import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
}), 'MusicNote');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MusicNote.js
// module id = 4961
// module chunks = 2